import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Main from './pages/Main';
import Header from './pages/Header';
import Footer from './pages/Footer';
import { NewsProvider, useNews } from './components/NewsContext';
import { UserProvider, useUser } from './components/UserContext';
import SplashScreen from './pages/SplashScreen';
import {
  initAmplitude,
  startHumanSessionTracking,
  trackAppOpen,
  trackEvent,
  trackPageView,
} from './amplitude';
import './App.css';

function AppInner() {
  const { firstLoadDone } = useNews();
  const { userData, loadingUser } = useUser();
  const location = useLocation();

  const [minTimeDone, setMinTimeDone] = useState(false);
  const [forceOpen, setForceOpen] = useState(false);
  const [showSplash, setShowSplash] = useState(true);
  const [hideSplash, setHideSplash] = useState(false);

  useEffect(() => {
    initAmplitude();
    startHumanSessionTracking();
  }, []);

  useEffect(() => {
    if (loadingUser) return;
    trackAppOpen();

    const path = location.pathname;
    let pageType = 'other';
    if (path === '/') pageType = 'home';
    else if (path.startsWith('/news/')) pageType = 'news';
    else if (path === '/news') pageType = 'news_list';
    else if (path.startsWith('/search')) pageType = 'search';
    else if (path.startsWith('/profile/')) pageType = 'profile';
    else if (
      ['/football-ukraine', '/championships', '/eurocups', '/biathlon', '/sports', '/tournaments']
        .includes(path)
    ) pageType = 'category';
    else if (!path.startsWith('/admin')) pageType = 'section';

    trackPageView(path, { page_type: pageType });
    if (pageType === 'category') {
      trackEvent('category_viewed', {
        category: path.slice(1),
        traffic_source: undefined,
      });
    } else if (pageType === 'section') {
      trackEvent('section_viewed', {
        section: path.split('/').filter(Boolean).at(-1),
      });
    }
  }, [loadingUser, location.pathname, userData?.role]);

  useEffect(() => {
    const minTimer = setTimeout(() => {
      setMinTimeDone(true);
    }, 3000);

    const forceTimer = setTimeout(() => {
      setForceOpen(true);
    }, 8000);

    return () => {
      clearTimeout(minTimer);
      clearTimeout(forceTimer);
    };
  }, []);

  useEffect(() => {
    if (minTimeDone && (firstLoadDone || forceOpen)) {
      setHideSplash(true);

      const timer = setTimeout(() => {
        setShowSplash(false);
      }, 650);

      return () => clearTimeout(timer);
    }
  }, [minTimeDone, firstLoadDone, forceOpen]);

  return (
    <>
      {showSplash && <SplashScreen hide={hideSplash} />}

      <div className="App">
        <Header />
        <Main />
        <Footer />
      </div>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <UserProvider>
        <NewsProvider>
          <AppInner />
        </NewsProvider>
      </UserProvider>
    </Router>
  );
}
